// ModernMessagingWrapper.jsx
import React from 'react';
import PropTypes from 'prop-types';
import MessagingHub from '../MessagingHub';
import LegacyFallback from './LegacyFallback';
import SuccessionThemeProvider from '../../SuccessionThemeProvider';

/**
 * ModernMessagingWrapper - Feature flag controlled messaging system
 * 
 * This component checks if the findbob_modernization feature is enabled
 * for the current user's company. If enabled, it renders the new modern
 * messaging system. Otherwise, it falls back to the legacy system.
 */
const ModernMessagingWrapper = (props) => {
  const { currentUser, ...restProps } = props;
  
  // Check if modernization is enabled for the current user's company
  const companyFeatures = currentUser?.company?.features || [];
  const userFeatures = currentUser?.features || [];
  
  const useModernMessaging = companyFeatures.includes('findbob_modernization') || userFeatures.includes('findbob_modernization');
  
  if (useModernMessaging) {
    return (
      <SuccessionThemeProvider company={currentUser?.company} user={currentUser}>
        <MessagingHub currentUser={currentUser} {...restProps} />
      </SuccessionThemeProvider>
    );
  }
  
  // Fallback to legacy system
  return <LegacyFallback currentUser={currentUser} {...restProps} />;
};

ModernMessagingWrapper.propTypes = {
  currentUser: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    company: PropTypes.shape({
      features: PropTypes.arrayOf(PropTypes.string)
    })
  }),
  // Additional props will be passed through to either system
};

export default ModernMessagingWrapper; 